














































import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class CrudDialog extends Vue {
  @Prop(Boolean) dialog!: boolean;
  @Prop(Boolean) readonly isEdit!: boolean;
  @Prop(Boolean) readonly isToolbar!: boolean;

  @Emit()
  private update(): boolean {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate();
  }

  @Emit()
  private create(): boolean {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate();
  }

  @Watch("dialog")
  onDialogChanged() {
    if (!this.dialog) {
      setTimeout(() => {
        (this.$refs.form as Vue & {
          resetValidation: () => void;
        }).resetValidation();
      }, 300);
    }
  }
}
